/* jscpd:ignore-start */
import { fetchFromVolatileServer } from "../fetchFromVolatileServer";
import { getServiceURL } from "../url";

export async function getFavorite(id: string | number) {
  if (id) {
    return fetchFromVolatileServer(
      `${getServiceURL()}/user/${id}/favoriterecipe`,
      {
        method: "GET",
        credentials: "include",
      },
    )
      .then((res) => {
        if (!res.ok) {
          console.error("Response not ok", res.status);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(err);
        return null;
      });
  }
  return null;
}
export async function getLikes(id: number | string) {
  if (id) {
    return fetchFromVolatileServer(`${getServiceURL()}/likes/${id}`, {
      method: "GET",
    })
      .then((res) => {
        if (!res?.ok) {
          console.error("Response not ok", res.status);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(err);
        return null;
      });
  }
}
/* jscpd:ignore-end */
